import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class ReportHistoryListItem extends SearchModelBase {
  id: number = 0;
  customerName : string = "";
  sentDate: string|null = null;
  fromSentDate: string|null = null;
  toSentDate: string|null = null;
  recipient : string = '';
  reportName: string = '';
  sentResult : string = '';
  fileId: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Sent Date', width: 120, dataIndex: 'sentDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'Report Name', width: 200, dataIndex: 'reportName' ,defaultColumnFocus:true }),
        XCol.Create({ col: 3, text: 'Customer', width: 180, dataIndex: 'customerName' }),
        XCol.Create({ col: 4, text: 'Recipient', width: 80, dataIndex: 'recipient', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 5, text: 'Result', width: 60, dataIndex: 'sentResult', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'File', width: 60, dataIndex: 'fileId', align: XCol.XAlignType.Center}),

    ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: ReportHistoryListItem.prototype.id, orderByAscending: false };

    public static formatData(data: ReportHistoryListItem[]) {
        return data.map((d: ReportHistoryListItem, index: number) => ({
          ...d,
        }));
    }
    
    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
      sentDate: {from: 'fromSentDate', to: 'toSentDate'},
    }
}
